import HeatScoreLabel from './HeatScoreLabel';
import './HeatScoreLabel.scss';

export default HeatScoreLabel;